import { render } from "./device-show.vue?vue&type=template&id=51b5eab4&scoped=true"
import script from "./device-show.vue?vue&type=script&lang=js"
export * from "./device-show.vue?vue&type=script&lang=js"

import "./device-show.vue?vue&type=style&index=0&id=51b5eab4&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51b5eab4"]])

export default __exports__